<template>
  <span class="message-type">
    {{ getMessageType(message.messageType) }}
    <i
      :class="{
        'fa fa-clock-o': message.timeout > 0,
        'fa fa-hand-pointer-o': message.timeout < 0
      }"
      aria-hidden="true"
    ></i>
    {{ getMessageTimeout(message) }}
  </span>
</template>

<script>
import { ANNOUNCEMENT_TYPES_DATA } from "@/helpers/constants";

export default {
  name: "MessageType",
  props: {
    message: Object
  },
  data() {
    return {
      messageTypes: ANNOUNCEMENT_TYPES_DATA
    };
  },
  methods: {
    getMessageType(type) {
      return this.messageTypes.find(types => types.messageType === type).value;
    },
    getMessageTimeout(message) {
      return message.timeout === 0 ? "Click to close" : `Auto close: ${message.timeout}`;
    }
  }
};
</script>

<style scoped></style>
